import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import home from "../assets/home.svg";
import bell from "../assets/bell.svg";
import add from "../assets/add.svg";
import logout from "../assets/logout.svg";
import search from "../assets/search.svg";
import american from "../../src/assets/american.png";
import indian from "../../src/assets/indian.png";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addLang } from "../Redux_Services/slices/langSlice";
import { translations } from "../translation/translate";
import { logoutReducer } from "../Redux_Services/slices/authSlice";
import { forwardRef } from "react";

const Navbar = forwardRef(({ searchInput, handleInputChange }, inputRef) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const langData = useSelector((state) => state.langSlice.langData || []);
  const [localSearchInput, setLocalSearchInput] = useState(searchInput); // Local state for input
  const [loadCompo, setLoader] = useState(true);

  const handleSearch = () => {
   
    setLoader(true);
    handleInputChange(localSearchInput, loadCompo);
  };

  const handleToggle = () => {
    const newLang = langData === "english" ? "hindi" : "english";
    dispatch(addLang(newLang));
  };

  const homeClick = () => {
    navigate("/home");
  };

  const handlePatientClick = () => {
    navigate("/add-patientdetails");
  };

  const searchClick = () => {
    navigate("/search-patient");
  };

  const logoutClick = () => {
    localStorage.removeItem("cookieFallback");
    dispatch(logoutReducer());
    navigate("/auth/login");
  };

  return (
    <div className="bg-[#C7CEE5] pt-10 px-28">
      <nav className="flex justify-between items-center px-8">
      <div className="flex items-center">
  <div className="text-4xl text-[#9669E0] font-bold">
    {translations[langData].scAn}
  </div>

  {location.pathname === "/search-patient" ? (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
    >
      <div className="relative max-w-xs ml-10 flex items-center">
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <img src={search} alt="search icon" className="w-4 h-4" />
        </span>

        <input
          ref={inputRef}
          type="text"
          value={localSearchInput}
          placeholder={translations[langData].search}
          onChange={(e) => setLocalSearchInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch(); // physical keyboards
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter") handleSearch(); // OSK keyboard
          }}
          className="pl-10 pr-4 py-2 w-full bg-transparent border-2 border-[#9669E0] rounded-lg focus:outline-none focus:ring-1 focus:ring-purple-500"
        />
 
 <div className="bg-purple-500 ml-2 rounded-xl hover:bg-purple-600"> 

        <button
          type="submit"
          className=" px-4 py-2 bg-purple-800 text-white rounded-lg "
          >
          {translations[langData].search}
        </button>
          </div>
      </div>
    </form>
  ) : (
    <button onClick={searchClick} className="flex items-center ml-6">
      <img src={search} className="w-8 h-8" alt="search icon" />
    </button>
  )}
</div>


        <div className="flex items-center space-x-20">
          <Link to={"/add-patient"} onClick={homeClick}>
            <img src={home} className="w-8 h-8" alt="home icon" />
          </Link>
          <Link to={"/notifications"}>
            <img src={bell} className="w-8 h-8" alt="notification icon" />
          </Link>
          <button onClick={handlePatientClick}>
            <img src={add} className="w-8 h-8" alt="add icon" />
          </button>
          <div className="flex items-center mr-[4px] w-10">
            <label className="inline-flex relative items-center mr-5 cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={langData === "hindi"}
                onChange={handleToggle}
              />
              <div className="w-16 h-9 bg-gray-200 rounded-full peer-focus:ring-green-300 transition-colors peer-checked:bg-[#9669E0] shadow-md">
                <span
                  className={`absolute top-[3px] ${
                    langData === "hindi" ? "left-[28px]" : "left-[3px]"
                  } flex items-center justify-center w-7 h-7 transition-transform duration-300 transform`}
                >
                  <span className="w-full h-full rounded-full overflow-hidden shadow-md">
                    {langData === "english" ? (
                      <img
                        src={american}
                        alt="English"
                        className="w-full h-full object-cover rounded-full"
                      />
                    ) : (
                      <img
                        src={indian}
                        alt="Hindi"
                        className="w-full h-full object-cover rounded-full"
                      />
                    )}
                  </span>
                </span>
              </div>
            </label>
          </div>
          <button onClick={logoutClick}>
            <img src={logout} className="w-8 h-8" alt="logout icon" />
          </button>
        </div>
      </nav>
    </div>
  );
});

export default Navbar;